module.exports = __webpack_public_path__ + "img/IT0000643841184.3e2fa7ff.png";